import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = `users`;

  const { match } = props;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();
  const [firstName, setFirstName] = useState(``);
  const [lastName, setLastName] = useState(``);
  const [email, setEmail] = useState(``);
  const [mobile, setMobile] = useState(``);
  const [national, setNational] = useState(``);
  const [identy, setIdenty] = useState(``);
  const [roles, setRoles] = useState(``);
  const [categories, setCategories] = useState(``);
  const [avatar, setAvatar] = useState(``);
  const [state, setState] = useState(``);
  const [sex, setSex] = useState(``);
  const [birthday, setBirthday] = useState(``);
  const [categoryId, setCategoryId] = useState(``);
  const [roleId, setRoleId] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const onChange = value => setCategoryId(value);
  const onChangeRole = value => setRoleId(value);
  const handleChangeState = value => setState(value);
  const handleChangeSex = value => setSex(value);


  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true);
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.users_store != undefined &&
          appReducer.users_store.error == false) ||
        (appReducer.users_update != undefined &&
          appReducer.users_update.error == false)
      ) {

      }
    }
    return () => setSubmitted(false);
  }, [appReducer.users_store, appReducer.users_update]);

  useEffect(() => {
    if (appReducer.users_edit != undefined && id != undefined) {
      let row = appReducer.users_edit.data;
      setId(row.id);
      setFirstName(row.first_name);
      setLastName(row.last_name);
      setEmail(row.email);
      setMobile(row.mobile);
      setNational(row.national);
      setIdenty(row.identy);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
      if (row.sex != null) {
        setSex({
          value: row.sex,
          label: row.sex == `male` ? `مرد` : `زن`,
        });
      }
      setBirthday(row.birthday);
      setAvatar(row.avatar_full);
      if (row.business != null) {
        setCategoryId({
          label: row.business.name,
          value: row.business.id,
        });
      }
      let multiRoles = [];
      if (row.role_users != null) {
        row.role_users.map((roleData) => {
          multiRoles.push({
            value: roleData.role.id,
            label: roleData.role.name
          });
        });
      }
      setRoleId(multiRoles);
    }
  }, [appReducer.users_edit]);

  useEffect(() => {
    if (appReducer.businesses_option_list != undefined) {
      setCategories(appReducer.businesses_option_list.data);
    }
  }, [appReducer.businesses_option_list]);

  useEffect(() => {
    if (appReducer.roles_option_list != undefined) {
      setRoles(appReducer.roles_option_list.data);
    }
  }, [appReducer.roles_option_list]);

  useEffect(() => {
    dispatch(actions.list(`businesses/option`));
    dispatch(actions.list(`roles/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form hasGrid={true}>


      <Template.Input
        mb={3}
        value={firstName}
        label="نام"
        name="first_name"
        type="text"
      />

      <Template.Input
        mb={3}
        value={lastName}
        label="نام خانوادگی"
        name="last_name"
        type="text"
      />

      <Template.Input
        mb={3}
        className="ltr"
        value={national}
        label="کدملی"
        name="national"
        type="text"
      />

      <Template.Input
        mb={3}
        value={identy}
        className="ltr"
        label="شماره شناسنامه"
        name="identy"
        type="text"
      />

      <Template.Input
        mb={3}
        required
        value={mobile}
        label="موبایل"
        name="mobile"
        className="ltr"
        type="text"
      />

      <Template.Input
        mb={3}
        value={email}
        className="ltr"
        label="ایمیل"
        name="email"
        type="email"
      />

      <Template.SingleSelect
        withLabel
        placeholder="جنسیت"
        onChange={handleChangeSex}
        name="sex"
        value={sex}
        options={[
          {
            value: "male",
            label: "مرد",
          },
          {
            value: "female",
            label: "زن",
          },
        ]}
      />

      <Template.Input
        mb={3}
        value={birthday}
        className="ltr"
        label="تاریخ تولد"
        name="birthday"
        type="text"
      />

      <Template.Input
        mb={3}
        label="رمزعبور"
        className="ltr"
        name="password"
        type="password"
      />
      <div className="form-group">
        <label>فروشگاه</label>
        <Template.SingleSelect
          onChange={onChange}
          placeholder="انتخاب ..."
          name="business_id"
          value={categoryId}
          options={categories}
        />
      </div>
      <div className="form-group">
        <label>نقش‌ها </label>
        <Select
          placeholder="انتخاب ..."
          isMulti
          isRtl={true}
          name="roles[]"
          options={roles}
          onChange={onChangeRole}
          value={roleId}
          className="basic-multi-select"
          classNamePrefix="select"
        />
      </div>

      <Template.SingleSelect
        withLabel
        required
        placeholder="وضعیت"
        onChange={handleChangeState}
        name="state"
        value={state}
        options={[
          {
            value: "active",
            label: "فعال",
          },
          {
            value: "deactive",
            label: "غیرفعال",
          },
        ]}
      />

      <Template.FileInput
        deleteUrl="users/destroy_image"
        rowId={id}
        value={avatar && [avatar]}
        name="avatar"
        label="تصویر کاربر"
      />


 
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>;
};
